import React, { useState } from 'react';
import { PaymentElement, useStripe, useElements } from '@stripe/react-stripe-js';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiCreditCard, FiLoader } = FiIcons;

const StripePaymentForm = ({ total, currency }) => {
  const stripe = useStripe();
  const elements = useElements();

  const [isProcessing, setIsProcessing] = useState(false);
  const [message, setMessage] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!stripe || !elements) {
      return;
    }

    setIsProcessing(true);

    const origin = import.meta.env.VITE_APP_URL || window.location.origin;

    const { error } = await stripe.confirmPayment({
      elements,
      confirmParams: {
        return_url: `${origin}/#/payment/success`,
      },
    });

    if (error.type === "card_error" || error.type === "validation_error") {
      setMessage(error.message);
    } else {
      setMessage("An unexpected error occurred.");
    }

    setIsProcessing(false);
  };

  return (
    <form id="payment-form" onSubmit={handleSubmit}>
      <PaymentElement id="payment-element" />
      
      <motion.button
        disabled={isProcessing || !stripe || !elements}
        id="submit"
        className="w-full mt-6 flex items-center justify-center px-4 py-3 bg-green-600 text-white font-semibold rounded-lg hover:bg-green-700 transition-colors disabled:bg-green-300"
        whileHover={{ scale: 1.02 }}
        whileTap={{ scale: 0.98 }}
      >
        {isProcessing ? (
          <motion.div
            animate={{ rotate: 360 }}
            transition={{ duration: 1, repeat: Infinity, ease: "linear" }}
          >
            <SafeIcon icon={FiLoader} className="w-5 h-5 mr-2" />
          </motion.div>
        ) : (
          <SafeIcon icon={FiCreditCard} className="w-5 h-5 mr-2" />
        )}
        <span>{isProcessing ? "Processing..." : `Pay ${currency}${total.toFixed(2)}`}</span>
      </motion.button>

      {message && <div id="payment-message" className="mt-4 text-sm text-red-600 text-center">{message}</div>}
    </form>
  );
};

export default StripePaymentForm;